import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { useStore } from 'effector-react';
import { Input } from 'antd';

import css from './SearchHeader.module.less';
import useTranslate from '@hooks/useTranslate';
import componentContent from './SearchHeader.content.json';
import users, { getList } from '@stores/users';
import SearchHeaderTable from '@components/SearchHeaderTable';

const { Search } = Input;

interface UsersListProps {}

const UsersListHeader: FunctionComponent<UsersListProps> = () => {
  const { filters: currentFilterParams } = useStore(users);
  const content = useTranslate(componentContent);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const searchRef = useRef<HTMLDivElement>(null);

  const onSearch = useCallback(
    (filter: string) => {
      getList({
        filters: {
          ...currentFilterParams,
          filter,
        },
        pagination: {
          pageSize: 10,
        },
      });
      setIsTableVisible(true);
    },
    [currentFilterParams],
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsTableVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      className={css.root}
      ref={searchRef}
      style={{ position: 'relative' }}
    >
      <Search
        className={css.searchInput}
        defaultValue={currentFilterParams.filter}
        allowClear
        onSearch={onSearch}
        placeholder={content.searchPlaceholder}
      />

      {isTableVisible && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            zIndex: 1000,
            backgroundColor: 'white',
            border: '1px solid #f0f0f0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}
        >
          <SearchHeaderTable />
        </div>
      )}
    </div>
  );
};

export default UsersListHeader;
